import React, {
  useState, useRef, useContext, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { StatusContext } from 'contexts/statusContext';
import {
  TextInput, Form, Button, CallTo,
} from 'components/common';
import { saleOtpRequest, getResendVerficationCode } from 'models/machinery';

const styles = {
  codeInput: {
    marginLeft: 10,
    fontSize: 40,
    fontWeight: '900',
    color: '#4d4e4e',
    textAlign: 'center',
  },
};

const CodeEnterence = ({
  t, machineData, onSubmit = () => {}, setCurrentStep,
}) => {
  const { setErrorState } = useContext(StatusContext);
  const [time, setTime] = useState(90);
  const [onResponse, setOnResponse] = useState(false);
  const [code, setCode] = useState(['', '', '', '', '', '']);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(time - 1);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [time]);

  let formRef = useRef();
  let code0 = useRef();
  let code1 = useRef();
  let code2 = useRef();
  let code3 = useRef();
  let code4 = useRef();
  let code5 = useRef();

  const inputChange = (name, value, line) => {
    if (line === 0) {
      if (value !== '') {
        code1.focus();
      }
    } else if (line === 1) {
      if (value === '') {
        code0.focus();
      } else {
        code2.focus();
      }
    } else if (line === 2) {
      if (value === '') {
        code1.focus();
      } else {
        code3.focus();
      }
    } else if (line === 3) {
      if (value === '') {
        code2.focus();
      } else {
        code4.focus();
      }
    } else if (line === 4) {
      if (value === '') {
        code3.focus();
      } else {
        code5.focus();
      }
    } else if (line === 5) {
      if (value === '') {
        code4.focus();
      } else {
        code5.blur();
      }
    }
    const newCode = code;
    newCode[line] = value;
    setCode(newCode);
  };

  const handleBackspaceDeletion = (e, line) => {
    const refs = [code0, code1, code2, code3, code4, code5];

    if (e.key === 'Backspace') {
      e.preventDefault();

      if (!code[line] && line > 0) {
        const newCode = [...code];
        newCode[line - 1] = '';
        setCode(newCode);
        refs[line - 1].focus();
      }
    }
  };

  const clear = (numberOfCode) => {
    const fields = {};
    const newCode = code;

    for (let i = numberOfCode; i < code.length; i++) {
      fields[`code${i}`] = '';
      newCode[i] = '';
    }

    formRef.setFieldsValue({
      ...fields,
    });
    setCode(newCode);
  };

  const sendCodeAgain = async () => {
    try {
      await getResendVerficationCode(
        machineData.requestId,
      );
      setErrorState({
        title: t('successful'),
        type: 'success',
        text: 'Onay kodunuz tekrar gönderildi.',
        buttonText: t('close'),
        onClickButton: () => setErrorState({}),
      });
      setTime(90);
    } catch (error) {
      console.log('verifyPhoneErr', error);
      if (error.status) {
        setErrorState({
          title: t('alert'),
          text: error.message,
          buttonText: t('close'),
          onClickButton: () => setErrorState({}),
        });
      }
    } finally {
      setOnResponse(false);
    }
  };

  const onFormSubmit = async () => {
    const codeToString = _.map(code).join('');
    onSubmit(codeToString);
    if (!onResponse) {
      try {
        setOnResponse(true);
        await saleOtpRequest(machineData.requestId, codeToString);
        setCurrentStep('Success');
      } catch (error) {
        console.log('codeEnterenceErr', error);
        if (error.status) {
          setErrorState({
            title: t('alert'),
            text: error.message,
            buttonText: t('close'),
            onClickButton: () => setErrorState({}),
          });
        }
      } finally {
        setOnResponse(false);
      }
    }
  };

  return (
    <div className="col-md-10 col-lg-7 offset-lg-1 mt-5 mt-lg-0">
      <Form
        formRef={(ref) => {
          formRef = ref;
        }}
        onFinish={onFormSubmit}
      >

        <div className="fs-22 mb-2">{t('stepNumber', { step: 3 })}</div>
        <div className="fs-22 fw-900 mb-3">{t('verifyYourPhoneNumber')}</div>
        <div className="mb-3">
          Onay kodunuz
          {' '}
          <span className="fw-700">{`+${machineData.customerPhone}`}</span>
          {' '}
          numaralı telefona iletilmiştir.
        </div>

        <div className="row mb-3">
          <div className="col">
            <div className="im-input-boxes" data-focus-to-first="true">
              <input className="im-input-boxes__input" type="hidden" autoComplete="off" name="Code" value="" />
              <TextInput
                className="im-input-boxes__box"
                style={styles.codeInput}
                name="code0"
                onChange={({ name, value }) => inputChange(name, value, 0)}
                onKeyDown={(e) => handleBackspaceDeletion(e, 0)}
                value={code[0]}
                onFocus={() => clear(0)}
                inputRef={(ref) => {
                  code0 = ref;
                }}
              />
              <TextInput
                className="im-input-boxes__box"
                style={styles.codeInput}
                name="code1"
                onChange={({ name, value }) => inputChange(name, value, 1)}
                onKeyDown={(e) => handleBackspaceDeletion(e, 1)}
                onFocus={() => clear(1)}
                value={code[1]}
                inputRef={(ref) => {
                  code1 = ref;
                }}
              />
              <TextInput
                className="im-input-boxes__box"
                style={styles.codeInput}
                name="code2"
                onChange={({ name, value }) => inputChange(name, value, 2)}
                onKeyDown={(e) => handleBackspaceDeletion(e, 2)}
                onFocus={() => clear(2)}
                value={code[2]}
                inputRef={(ref) => {
                  code2 = ref;
                }}
              />
              <TextInput
                className="im-input-boxes__box"
                style={styles.codeInput}
                name="code3"
                onChange={({ name, value }) => inputChange(name, value, 3)}
                onKeyDown={(e) => handleBackspaceDeletion(e, 3)}
                onFocus={() => clear(3)}
                value={code[3]}
                inputRef={(ref) => {
                  code3 = ref;
                }}
              />
              <TextInput
                className="im-input-boxes__box"
                style={styles.codeInput}
                name="code4"
                onChange={({ name, value }) => inputChange(name, value, 4)}
                onKeyDown={(e) => handleBackspaceDeletion(e, 4)}
                onFocus={() => clear(4)}
                value={code[4]}
                inputRef={(ref) => {
                  code4 = ref;
                }}
              />
              <TextInput
                className="im-input-boxes__box"
                style={styles.codeInput}
                name="code5"
                onChange={({ name, value }) => inputChange(name, value, 5)}
                onKeyDown={(e) => handleBackspaceDeletion(e, 5)}
                onFocus={() => clear(5)}
                value={code[5]}
                inputRef={(ref) => {
                  code5 = ref;
                }}
              />
            </div>
          </div>
        </div>
        <div className="row mb-3 ml-1">
          <div className="col">
            {time > 0
              ? <p className="fw-700">{t('waitForSendCode', { time })}</p>
              : (
                <a className="im-button im-button--blank" onClick={() => sendCodeAgain()}>
                  <i className="fa-solid fa-redo-alt mr-2" />
                  <span className="text-gray4">{t('sendNewCode')}</span>
                </a>
              ) }
          </div>
        </div>
        <div className="row mb-2 ml-1">
          <div className="col">
            <p className="fw-700">{t('didntReceiveVerificationCode')}</p>
          </div>
        </div>
        <div className="row  mb-2 ml-1">
          <div className="col">
            <p className="fw-400">
              Telefonunuzu doğrulamada sorun yaşıyorsanız,
              {' '}
              <CallTo style={{ fontWeight: '700', color: '#4d4e4e' }} tel="+90 (850) 885 46 25" />
              {' '}
              numaralı telefondan bize ulaşabilirsiniz.
            </p>
          </div>
        </div>
        <Button
          loading={onResponse}
          htmlType="submit"
          className="im-button im-button--primary im-button--fluid im-button--center mt-3 mb-5"
          label="Telefon Numaramı Doğrula"
        />
      </Form>
    </div>
  );
};

CodeEnterence.propTypes = {
  onSubmit: PropTypes.func,
  t: PropTypes.func,
  machineData: PropTypes.object,
  setCurrentStep: PropTypes.func,
};

export default CodeEnterence;
